import {
    Box,
    Button,
    Typography,
    Grid
} from '@mui/material'
import Banner1 from '../../assets/app/motor-insurance/privatecar-banner.png'
import Banner2 from '../../assets/app/motor-insurance/comprehensive-banner.png'
import { isTablet } from 'react-device-detect'
import { INSURANCE_MOTOR_LINK,  INSURANCE_CAR_LINK} from '../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppInsuranceRenewal: React.FC = () => {
    const { t } = useTranslation()

    // 去购买保险
    const buyInsurance = (link: string) => {
        window.open(link)
    }

    const data = [
        {
            'backgroundImage': Banner1,
            'title': t('t260'),
            'content': t('t266'),
            'data': [
                t('t261'),
                t('t262'),
                t('t263'),
                t('t264'),
                t('t265')
            ],
            'buttonTitle': t('t267'),
            'link': INSURANCE_CAR_LINK,
        },
        {
            'backgroundImage': Banner2,
            'title': t('t268'),
            'content': '',
            'data': [
                t('t269'),
                t('t270'),
                t('t271'),
                t('t272'),
            ],
            'buttonTitle': t('t267'),
            'link': INSURANCE_MOTOR_LINK,
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Grid item key={index} xs={isTablet ? 6 : 12}>
                <Box sx={{
                    height: '100%',
                    backgroundImage: `url(${data[index]['backgroundImage']})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'start',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '10px',
                }}>

                    <Box sx={{
                        width: '100%',
                        height: '100%',
                        paddingLeft: '12px',
                        paddingRight: '12px',
                        paddingTop: (window.innerWidth - 48) * (isTablet ? 0.035 : 0.076),
                        display: 'flex',
                    }}>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '10px',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                            paddingTop: '40px',
                            paddingBottom: '40px',
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            boxShadow: '0px 10px 80px 3px #0000001A',
                        }}>
                            <Box>

                                <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                                    {data[index]['title']}
                                </Typography>

                                {data[index]['data'].map((subItem, subIndex) => (
                                    renderTitleItem(subItem, subIndex)
                                ))}

                                {
                                    data[index]['content'] !== '' ? (<Typography style={{fontStyle: 'italic', fontSize: '14px' ,fontWeight: '400', color: '#6B6B6B'}} paddingTop={'14px'} paddingLeft={'8px'} >
                                        {data[index]['content']}
                                    </Typography>) : (<Box></Box>)
                                }
                            </Box>

                            <Box paddingTop={'40px'} sx={{ textDecoration: 'none' }}>
                                <Button onClick={() => buyInsurance(data[index]['link'])}
                                    sx={{
                                        borderRadius: '30px',
                                        width: '200px',
                                        height: '60px',
                                        bgcolor: '#FFC107',
                                        border: '1px solid #FFC107',
                                        color: '#141F39',
                                        '&:hover': {
                                            bgcolor: '#FFC107',
                                        },
                                        textTransform: 'none',
                                    }}
                                >
                                    {data[index]['buttonTitle']}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Grid>
        )
    }

    const renderTitleItem = (item: string, index: number) => {
        return (
            <Box sx={{paddingLeft: '10px', paddingRight: '10px'}}>
                <Typography key={index} fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'14px'}>
                {item}
            </Typography>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '60px',
                backgroundColor: '#FFFDF7',
            }}
        >

            <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingLeft={'10px'} paddingRight={'10px'}>
                {t('t257')}
            </Typography>

            <Typography fontSize={20} fontWeight={600} color={'#141F39'} textAlign={'center'} paddingTop={'20px'} paddingLeft={'20px'} paddingRight={'20px'}>
                {t('t258')} {<span style={{fontStyle: 'italic', fontSize: '20px' ,fontWeight: '500',}}>{t('t259')}</span>}
            </Typography>

            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '45px',
            }}>
                <Grid container rowSpacing={isTablet ? 0 : 3} columnSpacing={isTablet ? 2 : 0} alignContent={'stretch'}>
                    {data.map((item, index) => (
                        renderItem(index)
                    ))}
                </Grid>
            </Box>
        </Box >
    )
}

// ======================= EXPORT
export default SMAppInsuranceRenewal
